import clsx from 'clsx';

const ChartButton = ({
    label,
    active,
    onClick,
    disabled,
    id
}: {
    label: JSX.Element | string;
    active: boolean;
    onClick: () => void;
    disabled: boolean;
    id: string;
}) => (
    <button data-testid={`btn__${id}`} id={id} className={clsx('chart-history-price__button', active && 'isActive')} onClick={onClick} disabled={disabled} type='button'>
        {label}
    </button>
);

export default ChartButton;
